import type { BffApiClient } from "@/app/api-client"
import { NotFoundError } from "@/app/sdk/errors"
import type { InferRequestType } from "hono"

export type QueryInput = InferRequestType<
  BffApiClient["api"]["collections"][":id"]["$get"]
>["param"]

export const getCollectionQueryParams = (
  apiClient: BffApiClient,
  queryInput: QueryInput,
) => {
  return {
    queryKey: ["collections", "byId", queryInput],
    queryFn: async () => {
      const response = await apiClient.api.collections[":id"].$get({
        param: queryInput,
      })

      if (!response.ok) {
        const error = await response.json()
        if (response.status === 404) {
          throw new NotFoundError("Collection not found")
        }
        throw error
      }

      return response.json()
    },
  }
}

type QueryFn = ReturnType<typeof getCollectionQueryParams>["queryFn"]

export type QueryResponse = Awaited<ReturnType<QueryFn>>
